
import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { MessageService } from '../../../services/core/message.service';
import { ValuesService } from '../../../values/values.service';

@Directive({
    standalone: true,
    selector: 'ui-infinite-scroll, [ui-infinite-scroll]'
})
export class UiInfiniteScrollDirective {

    /**
     * Use scrollThreshold when you need to have a bigger area at the end of the scroll at wich point scrollEnd should be trigegred
     * * default value is 0 - scrollEnd is triggered ar the very bottom of the scrollable area
     * @type {number}
     */
    @Input() scrollThreshold = 0;

    private currentPosition = Number.MIN_SAFE_INTEGER;
    private scrolling = false;

    constructor(
        private readonly el: ElementRef,
        private readonly messageService: MessageService,
        private readonly valuesService: ValuesService
    ) {}

    @HostListener('scroll', ['$event']) onWindowScroll(event) {
        let scroll = Math.ceil(event.target.scrollTop);
        if (scroll <= this.currentPosition) {
            this.currentPosition = scroll;
            return;
        }
        this.currentPosition = scroll;
        let reachedEnd = (event.target.offsetHeight + scroll + this.scrollThreshold) >= event.target.scrollHeight;

        if (reachedEnd && !this.scrolling) {
            this.scrolling = true;
            this.messageService.sendMessage(this.valuesService.events.scrollEnd, {elem: this.el});
            setTimeout(()=> {
                reachedEnd = false;
                this.scrolling = false;
            }, 1000);
        }
    }

}